var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardArrowDownGray24X24({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.625 9 3.88 3.88L16.385 9a.996.996 0 1 1 1.41 1.41L13.205 15a.996.996 0 0 1-1.41 0l-4.59-4.59a.996.996 0 0 1 0-1.41c.39-.38 1.03-.39 1.42 0z",
    fill: "#9EA4AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowDownGray24X24);
export default __webpack_public_path__ + "static/media/keyboard_arrow_down_gray_24x24.ab342269a2f397802360632f67f8a0ed.svg";
export { ForwardRef as ReactComponent };